module.exports = "mutation DeletePanelLayout($id: ID!) {\n  deletePanelLayout(id: $id) {\n    deleted\n  }\n}\n"